// @flow
import { APICore } from "./apiCore";

const api = new APICore();

// account
function ApiGetAllKategoriRoom(params: any): any {
  const baseUrl = "/api/admin/kategoriroom";
  return api.get(`${baseUrl}`, params);
}
function ApiGetAllRoom(params: any): any {
  const baseUrl = "/api/admin/room";
  return api.get(`${baseUrl}`, params);
}
function ApiPostCategoryRoom(params: any): any {
  const baseUrl = "/api/admin/kategoriroom";
  return api.create(`${baseUrl}`, params);
}
function ApiPostRoom(params: any): any {
  const baseUrl = "/api/admin/room";
  return api.create(`${baseUrl}`, params);
}
function ApiEditKategoriRoom(params: any, id: any): any {
  const baseUrl = "/api/admin/kategoriroom/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiEditRoom(params: any, id: any): any {
  const baseUrl = "/api/admin/room/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiDeleteRoom(id: any): any {
  const baseUrl = "/api/admin/room/" + id;
  return api.delete(`${baseUrl}`);
}
function ApiDeleteKategoriRoom(id: any): any {
  const baseUrl = "/api/admin/kategoriroom/" + id;
  return api.delete(`${baseUrl}`);
}

export {
  ApiGetAllKategoriRoom,
  ApiGetAllRoom,
  ApiPostCategoryRoom,
  ApiPostRoom,
  ApiEditKategoriRoom,
  ApiEditRoom,
  ApiDeleteRoom,
  ApiDeleteKategoriRoom,
};
